import { Box, DialogContent, DialogTitle, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { PathDialog } from '../../../components/documented/PathDialog';
import { SystemAlert } from '../../../model/reporting/systemAlert';
import { useAppThunkDispatch } from '../../../redux/configureStore';
import { selectAccountId } from '../../../redux/selectors/accountSelectors';

interface Props {
  isAddCompliancePeriodOpen: boolean;
  handleDialogClose: () => void;
  alert: SystemAlert | null;
}

export const ShowSystemAlertDetailDialog: React.FC<Props> = ({
  isAddCompliancePeriodOpen,
  handleDialogClose,
  alert,
}) => {
  const { t } = useTranslation('monitoring');
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const accountId = useSelector(selectAccountId);
  const dispatch = useAppThunkDispatch();

  const handleDateChange = (newDate: Date | null) => {
    setSelectedDate(newDate);
  };

  const onSubmit = () => {};

  const closeDialog = () => {
    handleDialogClose();
  };

  return (
    <PathDialog
      isOpen={isAddCompliancePeriodOpen}
      handleClose={closeDialog}
      isLoading={isLoading}
      isValid={selectedDate !== null}
    >
      <>
        <DialogTitle>
          {alert
            ? t('systemAlertDialog.titleWithId', { id: alert.id })
            : t('systemAlertDialog.title')}
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 1 }}>
            {t('systemAlertDialog.description')}
          </Typography>

          {/* Scrollable Description Box */}
          {alert?.description && (
            <Box
              sx={{
                border: '1px solid #ccc',
                borderRadius: '4px',
                padding: '8px',
                width: '100%',
                maxHeight: '200px',
                overflowY: 'auto',
                overflowX: 'hidden',
                fontFamily: 'monospace',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                userSelect: 'text',
                display: 'block',
                boxSizing: 'border-box',
              }}
            >
              {alert.description}
            </Box>
          )}
        </DialogContent>
      </>
    </PathDialog>
  );
};

export default ShowSystemAlertDetailDialog;
